<template>
  <div class="invite-page">
    <div class="bg-decoration"></div>
    <div class="bg-decoration-2"></div>

    <div class="main-content">

      <!-- 未通过签名验证引导 -->
      <div v-if="!authVerified" class="no-access">
        <div v-if="authVerifying" class="no-access-card">
          <i class="el-icon-loading no-access-icon"></i>
          <p class="no-access-title">正在验证身份...</p>
        </div>
        <div v-else-if="authDeniedReason" class="no-access-card denied">
          <i class="el-icon-warning no-access-icon"></i>
          <p class="no-access-title">无法参与活动</p>
          <p class="no-access-desc">{{ authDeniedReason }}</p>
        </div>
        <div v-else class="no-access-card">
          <i class="el-icon-warning-outline no-access-icon"></i>
          <p class="no-access-title">请通过App内活动链接进入</p>
          <p class="no-access-desc">本活动页需在陌撩漂流瓶App内打开，方能识别您的身份并参与奖励活动。</p>
        </div>
      </div>

      <template v-else>
        <!-- 顶部返回 + 品牌 -->
        <!-- <div class="top-bar">
          <span class="back-btn" @click="goBack"><i class="el-icon-arrow-left"></i> 活动中心</span>
          <span class="brand-name">陌撩漂流瓶</span>
        </div> -->

        <!-- 主视觉 Hero -->
        <div class="hero-card">
          <h1 class="hero-title">邀请好友，共享奖励</h1>
          <p class="hero-desc">预填充手机号，注册后自动绑定邀请关系，共享奖励。</p>
        </div>

        <!-- 内容卡片 -->
        <div class="tabs-card">

          <!-- 邀请流程引导卡片 -->
          <div class="bind-card">
            <div class="card-title">
              <i class="el-icon-guide"></i>
              <span>邀请流程</span>
            </div>

            <div class="flow-steps">
              <!-- 步骤1：下载App -->
              <div class="flow-step">
                <div class="step-left">
                  <div class="step-num">1</div>
                  <div class="step-line"></div>
                </div>
                <div class="step-content">
                  <div class="step-header">
                    <i class="el-icon-download step-icon"></i>
                    <span class="step-title">下载并打开App</span>
                  </div>
                  <p class="step-desc">在应用商店搜索「陌撩漂流瓶」，下载安装并打开应用程序。您也可以点击<a class="download-link" href="https://www.moliaos.com/#/DLW" target="_blank" rel="noopener" @click="onDownloadLinkClick">此链接</a>，跳转至应用下载页面。</p>
                </div>
              </div>

              <!-- 步骤2：手机号注册 -->
              <div class="flow-step">
                <div class="step-left">
                  <div class="step-num">2</div>
                  <div class="step-line"></div>
                </div>
                <div class="step-content">
                  <div class="step-header">
                    <i class="el-icon-mobile step-icon"></i>
                    <span class="step-title">手机号注册</span>
                  </div>
                  <p class="step-desc">使用手机号码注册新账户，需完成验证码验证、设置登录密码等完整注册流程。</p>
                </div>
              </div>

              <!-- 步骤3：进入活动页 -->
              <div class="flow-step">
                <div class="step-left">
                  <div class="step-num">3</div>
                  <div class="step-line"></div>
                </div>
                <div class="step-content">
                  <div class="step-header">
                    <i class="el-icon-place step-icon"></i>
                    <span class="step-title">进入活动页面</span>
                  </div>
                  <p class="step-desc">依次点击「我的」→ 活动轮播图 → 选择「限时邀请奖励活动」，进入邀请页。</p>
                </div>
              </div>

              <!-- 步骤4：绑定邀请码 -->
              <div class="flow-step last">
                <div class="step-left">
                  <div class="step-num">4</div>
                </div>
                <div class="step-content">
                  <div class="step-header">
                    <i class="el-icon-connection step-icon"></i>
                    <span class="step-title">绑定邀请码</span>
                  </div>
                  <p class="step-desc">在邀请码绑定界面，输入或粘贴ID <span class="copyable-id-wrapper" @click="copyUserId"><b class="copyable-id" :class="{ 'copy-success': idCopied }">{{ displayUserId }}</b><span class="copy-hint" v-if="!idCopied"><i class="el-icon-document-copy"></i> 点击复制</span><span class="copy-hint copied" v-else><i class="el-icon-circle-check"></i> ID已复制</span></span>，完成绑定即可参与奖励。</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 快速绑定流程卡片 -->
          <div class="bind-card">
            <div class="card-section-title">
              <i class="el-icon-s-promotion"></i>
              <span>快速绑定流程</span>
            </div>

            <div class="bind-body">
              <p class="prefill-desc">输入手机号，<b>2小时内</b>注册将自动绑定邀请关系，无需手动输入邀请码。</p>

              <el-input
                v-model="prefillPhone"
                placeholder="请输入手机号码"
                clearable
                maxlength="11"
                :disabled="prefillLoading"
                @keyup.enter.native="handlePrefill"
              >
                <i slot="prefix" class="el-input__icon el-icon-mobile"></i>
              </el-input>

              <!-- 手机号已注册提示 -->
              <div v-if="phoneExistsMsg" class="phone-exists-notice">
                <i class="el-icon-warning-outline"></i>
                <span>{{ phoneExistsMsg }}</span>
              </div>

              <el-button
                type="primary"
                class="submit-btn"
                :loading="prefillLoading"
                :disabled="!prefillPhone || prefillLoading"
                @click="handlePrefill"
              >
                立即预填充
              </el-button>

              <p class="bind-tip">已注册的手机号无法预填充，仅限未注册新用户。恶意预填充将被永久取消资格。</p>
            </div>
          </div>

          <!-- 活动规则 -->
          <div class="bind-card">
            <div class="card-section-title no-border">
              <i class="el-icon-document-checked"></i>
              <span>活动规则</span>
            </div>
            <ol class="rules-list">
              <li>按上方流程完成注册与绑定，或通过「快速绑定」预填充手机号。</li>
              <li>预填充后，<b>2小时内</b>注册App将自动绑定邀请关系。</li>
              <li>已注册的手机号<b>无法预填充</b>，仅限未注册的新用户。</li>
              <li>恶意预填充手机号将被<b>永久取消资格</b>，请勿滥用。</li>
            </ol>
          </div>
        </div>

        <div class="bottom-bar">&copy; 2026 陌撩漂流瓶</div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  InviteFriendPrefillApi,
  InviteFriendAutoBindApi,
  InviteBindingApi,
  VerifySignatureApi
} from '@/api/api.js'
import { setToken } from '@/utils/dataStorage.js'
import { setAuthParams, buildAuthQuery, isAuthParamsComplete } from '@/utils/authParams.js'

export default {
  name: 'InviteFriendActivity',
  data() {
    return {
      userId: '',
      authVerified: false,
      authVerifying: true,
      authDeniedReason: '',
      // 绑定状态
      bindingLoading: false,
      bindingDetail: null,
      // 自动绑定
      autoBindLoading: false,
      autoBindChecked: false,
      autoBindSuccess: false,
      // 手机号预填充
      prefillPhone: '',
      prefillLoading: false,
      phoneExistsMsg: '',
      // 复制ID
      idCopied: false,
    }
  },
  computed: {
    // 动态显示用户ID，API未返回时降级显示提示
    displayUserId() {
      return this.userId || '获取失败';
    }
  },
  mounted() {
    this.initContext();
  },
  methods: {
    // 返回活动中心
    goBack() {
      this.$router.push({ path: '/activity/list', query: buildAuthQuery(this.$route.query) });
    },
    // 从 URL 读取签名参数并验证身份
    initContext() {
      const query = this.$route.query || {};
      if (query.token) {
        setToken(query.token);
      }
      // 参数完整性检查：签名参数齐全才请求后端验证签名
      if (isAuthParamsComplete(query)) {
        setAuthParams(query);
        VerifySignatureApi().then(res => {
          if (res && res.code === 200 && res.data && res.data.user_id) {
            this.userId = String(res.data.user_id);
            this.authVerified = true;
            // 先查询绑定状态，再尝试自动绑定
            this.fetchBindingAndAutoBind();
          } else {
            // API返回成功但userId为空
            this.authDeniedReason = '身份验证返回数据异常，请重新从App内打开';
            this.authVerified = false;
          }
        }).catch(err => {
          // 提取 403 业务限制原因，显示友好限制提示
          const detail = err && err.response && err.response.data && err.response.data.detail;
          if (detail) {
            this.authDeniedReason = detail;
          }
          this.authVerified = false;
        }).finally(() => {
          this.authVerifying = false;
        });
      } else {
        // 参数不全，直接拒绝
        this.authVerified = false;
        this.authVerifying = false;
      }
    },
    // 查询绑定状态并尝试自动绑定
    fetchBindingAndAutoBind() {
      this.bindingLoading = true;
      InviteBindingApi().then(res => {
        if (res && res.code === 200 && res.data) {
          // 如果有 inviter_user_id 说明已绑定
          this.bindingDetail = res.data.inviter_user_id ? res.data : null;
          if (this.bindingDetail) {
            // 已绑定，无需自动绑定
            this.autoBindChecked = true;
          } else {
            // 未绑定，尝试自动绑定
            this.tryAutoBind();
          }
        } else if (res) {
          this.$message.error(res.msg || '获取绑定信息失败');
        }
      }).catch(() => {
        this.$message.error('网络异常，请稍后重试');
      }).finally(() => {
        if (this.bindingDetail || this.autoBindChecked) {
          this.bindingLoading = false;
        }
      });
    },
    // 自动绑定：利用后端从URL签名参数中解析出的userId，自动完成绑定
    tryAutoBind() {
      this.autoBindLoading = true;
      InviteFriendAutoBindApi().then(res => {
        this.autoBindChecked = true;
        if (res && res.code === 200 && res.data) {
          // 自动绑定成功
          this.autoBindSuccess = true;
          this.$message.success('自动绑定成功');
          // 刷新绑定详情
          this.refreshBinding();
        } else {
          // 无匹配预填充记录，正常情况
          this.autoBindSuccess = false;
        }
      }).catch(err => {
        this.autoBindChecked = true;
        this.autoBindSuccess = false;
        const detail = err && err.response && err.response.data && err.response.data.detail;
        if (detail) {
          this.$message.error(detail);
        }
      }).finally(() => {
        this.autoBindLoading = false;
        this.bindingLoading = false;
      });
    },
    // 刷新绑定详情（自动绑定成功后调用）
    refreshBinding() {
      InviteBindingApi().then(res => {
        if (res && res.code === 200 && res.data) {
          this.bindingDetail = res.data.inviter_user_id ? res.data : null;
        }
      }).catch(() => {});
    },
    // 手机号预填充提交（含已注册校验）
    handlePrefill() {
      const phone = (this.prefillPhone || '').trim();
      this.phoneExistsMsg = '';
      if (!phone) {
        this.$message.warning('请输入手机号码');
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.warning('请输入正确的11位手机号码');
        return;
      }
      this.prefillLoading = true;
      InviteFriendPrefillApi({ invitee_phone: phone }).then(res => {
        if (res && res.code === 200) {
          this.$message.success('预填充成功，2小时内注册将自动绑定');
          this.prefillPhone = '';
          this.phoneExistsMsg = '';
        } else if (res) {
          this.$message.error(res.msg || '预填充失败');
        }
      }).catch(err => {
        const detail = err && err.response && err.response.data && err.response.data.detail;
        if (detail) {
          // 手机号已注册的特定提示
          if (detail.indexOf('已注册') !== -1) {
            this.phoneExistsMsg = detail;
          }
          this.$message.error(detail);
        } else {
          this.$message.error('网络异常，请稍后重试');
        }
      }).finally(() => {
        this.prefillLoading = false;
      });
    },
    // 性别文本（绑定状态条可能使用）
    sexText(sex) {
      if (sex === 1) return '男';
      if (sex === 2) return '女';
      return '未知';
    },
    // 点击下载链接时，先复制ID再跳转
    onDownloadLinkClick() {
      if (this.userId) {
        // 优先使用 Clipboard API（异步），失败则降级同步复制
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(this.userId).then(() => {
            this.onIdCopySuccess();
          }).catch(() => {
            this.fallbackCopyText(this.userId);
          });
        } else {
          this.fallbackCopyText(this.userId);
        }
      }
      // 不阻止默认行为，链接正常跳转
    },
    // 点击复制用户ID到剪贴板
    copyUserId() {
      if (!this.userId) {
        this.$message.warning('无法复制，用户ID未获取');
        return;
      }
      // 优先使用 Clipboard API，降级使用 execCommand
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.userId).then(() => {
          this.onIdCopySuccess();
        }).catch(() => {
          this.fallbackCopyText(this.userId);
        });
      } else {
        this.fallbackCopyText(this.userId);
      }
    },
    // ID复制成功反馈
    onIdCopySuccess() {
      this.idCopied = true;
      this.$message.success('ID已复制：' + this.userId);
      setTimeout(() => { this.idCopied = false; }, 2000);
    },
    // 兼容旧浏览器的复制方案
    fallbackCopyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.onIdCopySuccess();
      } catch (e) {
        this.$message.error('复制失败，请手动复制');
      }
      document.body.removeChild(textarea);
    }
  }
}
</script>

<style scoped>
.invite-page {
  min-height: 100vh;
  background: linear-gradient(160deg, #fff5f9 0%, #fff9ff 40%, #fdf2f8 100%);
  position: relative;
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  top: -160px;
  right: -160px;
  width: 420px;
  height: 420px;
  background: radial-gradient(circle, rgba(255, 96, 197, 0.18) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.bg-decoration-2 {
  position: absolute;
  bottom: -120px;
  left: -120px;
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(168, 85, 247, 0.12) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 8s ease-in-out infinite reverse;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(20px, 20px) scale(1.08); }
}

.main-content {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 24px 18px 40px;
  position: relative;
  z-index: 1;
}

/* 未授权引导 */
.no-access-card {
  background: #fff;
  border-radius: 24px;
  padding: 56px 28px;
  text-align: center;
  box-shadow: 0 12px 40px rgba(255, 96, 197, 0.12);
  margin-top: 80px;
}
.no-access-card.denied {
  border: 1px solid #fde2e2;
  background: linear-gradient(135deg, #fff5f5 0%, #fff0f5 100%);
}
.no-access-card.denied .no-access-icon {
  color: #f56c6c;
}
.no-access-icon {
  font-size: 52px;
  color: #ff60c5;
  margin-bottom: 16px;
  display: block;
}
.no-access-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}
.no-access-desc {
  font-size: 14px;
  color: #999;
  line-height: 1.7;
}

/* 顶部栏 */
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.back-btn {
  font-size: 14px;
  color: #ff60c5;
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.back-btn i {
  margin-right: 4px;
}
.brand-name {
  font-size: 14px;
  font-weight: 700;
  background: linear-gradient(135deg, #ff60c5 0%, #a855f7 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Hero */
.hero-card {
  background: linear-gradient(135deg, #ff60c5 0%, #a855f7 100%);
  border-radius: 26px;
  padding: 24px;
  color: #fff;
  text-align: center;
  box-shadow: 0 16px 44px rgba(255, 96, 197, 0.35);
  position: relative;
  overflow: hidden;
  margin-bottom: 16px;
}
.hero-card::after {
  content: '';
  position: absolute;
  top: -40px;
  right: -40px;
  width: 160px;
  height: 160px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.18) 0%, transparent 70%);
  border-radius: 50%;
}
.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.22);
  padding: 5px 14px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 14px;
}
.hero-badge .dot {
  width: 6px;
  height: 6px;
  background: #fff;
  border-radius: 50%;
  animation: blink 1.4s ease-in-out infinite;
}
@keyframes blink {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
}
.hero-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 6px;
  letter-spacing: 1px;
}
.hero-cashback {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
}
.hero-cashback .num {
  font-size: 56px;
  font-weight: 800;
  line-height: 1;
  vertical-align: -8px;
  margin: 0 2px;
  text-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}
.hero-cashback .pct {
  font-size: 28px;
  font-weight: 800;
}
.hero-desc {
  font-size: 13px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.92);
}
.hero-desc b {
  font-weight: 700;
}
.hero-stats {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.16);
  border-radius: 16px;
  padding: 14px 0;
}
.stat-item {
  flex: 1;
  text-align: center;
}
.stat-num {
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 4px;
}
.stat-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
}
.stat-divider {
  width: 1px;
  height: 30px;
  background: rgba(255, 255, 255, 0.3);
}

/* 内容卡片容器 */
.tabs-card {
  background: #fff;
  border-radius: 22px;
  padding: 4px 18px 20px;
  box-shadow: 0 8px 28px rgba(255, 96, 197, 0.1);
  margin-bottom: 16px;
  border: 1px solid rgba(255, 96, 197, 0.06);
}

/* 卡片 */
.bind-card {
  padding: 16px 0;
  margin-bottom: 0;
}
.bind-card + .bind-card {
  border-top: 1px dashed #f0d6e6;
}
.card-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 14px;
}
.card-title i {
  color: #ff60c5;
  margin-right: 8px;
  font-size: 18px;
}
.card-section-title {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 700;
  color: #333;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px dashed #f0d6e6;
  margin-bottom: 12px;
}
.card-section-title.no-border {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}
.card-section-title i {
  color: #ff60c5;
  margin-right: 8px;
  font-size: 16px;
}
.rules-list {
  margin: 0;
  padding-left: 18px;
  color: #666;
  font-size: 13px;
  line-height: 1.9;
}
.rules-list li {
  margin-bottom: 4px;
}
.rules-list b {
  color: #ff60c5;
}

.bind-body {
  min-height: 40px;
}
.bind-card >>> .el-input__inner {
  border-radius: 14px;
  border-color: #f0d6e6;
  height: 48px;
  font-size: 16px;
}
.bind-card >>> .el-input__inner:focus {
  border-color: #ff60c5;
}
.submit-btn {
  width: 100%;
  margin-top: 16px;
  height: 48px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #ff60c5 0%, #a855f7 100%);
  border: none;
  box-shadow: 0 8px 20px rgba(255, 96, 197, 0.35);
}
.submit-btn:disabled {
  opacity: 0.6;
}
.bind-tip {
  margin-top: 14px;
  font-size: 12px;
  color: #aaa;
  text-align: center;
}

/* 流程步骤引导 */
.flow-steps {
  padding-left: 4px;
}
.flow-step {
  display: flex;
  min-height: 64px;
}
.flow-step.last {
  min-height: auto;
}
.step-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 36px;
  flex-shrink: 0;
  margin-right: 12px;
}
.step-num {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff60c5 0%, #a855f7 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 3px 10px rgba(255, 96, 197, 0.3);
}
.step-line {
  width: 2px;
  flex: 1;
  background: linear-gradient(180deg, #e0b4d8 0%, #d4b0e8 100%);
  margin: 6px 0;
  border-radius: 1px;
}
.flow-step.last .step-line {
  display: none;
}
.step-content {
  flex: 1;
  padding-bottom: 18px;
}
.flow-step.last .step-content {
  padding-bottom: 0;
}
.step-header {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.step-icon {
  font-size: 16px;
  color: #ff60c5;
  margin-right: 6px;
}
.step-title {
  font-size: 15px;
  font-weight: 700;
  color: #333;
}
.step-desc {
  font-size: 13px;
  color: #888;
  line-height: 1.6;
  margin: 0;
}
.step-desc b {
  color: #ff60c5;
  font-weight: 700;
}
/* 步骤描述中的下载链接高亮 */
.step-desc a.download-link {
  color: #ff60c5;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: color 0.2s ease;
}
.step-desc a.download-link:hover {
  color: #a855f7;
}
.step-desc a.download-link:active {
  color: #7c3aed;
}
/* 可点击复制的ID区域 */
.step-desc .copyable-id-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 3px 10px 3px 8px;
  border-radius: 8px;
  border: 1.5px dashed #ff60c5;
  background: rgba(255, 96, 197, 0.06);
  transition: all 0.25s ease;
  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  vertical-align: middle;
}
.step-desc .copyable-id-wrapper:hover {
  background: rgba(255, 96, 197, 0.13);
  border-color: #e050a8;
  box-shadow: 0 2px 10px rgba(255, 96, 197, 0.18);
}
.step-desc .copyable-id-wrapper:active {
  transform: scale(0.96);
  background: rgba(255, 96, 197, 0.2);
}
.step-desc b.copyable-id {
  color: #ff60c5;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.5px;
}
.step-desc b.copyable-id.copy-success {
  color: #a855f7;
}
.step-desc .copy-hint {
  font-size: 11px;
  color: #ff60c5;
  font-weight: 600;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 2px;
}
.step-desc .copy-hint i {
  font-size: 13px;
}
.step-desc .copy-hint.copied {
  color: #a855f7;
}
.step-desc .copyable-id-wrapper:has(.copy-hint.copied) {
  border-color: #a855f7;
  border-style: solid;
  background: rgba(168, 85, 247, 0.08);
}

/* 预填充描述 */
.prefill-desc {
  font-size: 13px;
  color: #888;
  margin-bottom: 14px;
  line-height: 1.6;
}
.prefill-desc b {
  color: #ff60c5;
  font-weight: 700;
}

/* 手机号已注册提示 */
.phone-exists-notice {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: #fff5f5;
  border: 1px solid #fde2e2;
  border-radius: 12px;
  color: #f56c6c;
  font-size: 13px;
  margin-top: 12px;
  line-height: 1.6;
}
.phone-exists-notice i {
  font-size: 16px;
  flex-shrink: 0;
}

.bottom-bar {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin-top: 24px;
}

/* 响应式 - 大屏 */
@media (min-width: 481px) {
  .main-content {
    padding: 40px 18px 48px;
  }
  .tabs-card {
    padding: 8px 22px 24px;
  }
}

/* 响应式 - 小屏 */
@media (max-width: 360px) {
  .hero-cashback .num {
    font-size: 46px;
  }
  .hero-cashback .pct {
    font-size: 24px;
  }
  .hero-title {
    font-size: 20px;
  }
  .step-title {
    font-size: 14px;
  }
  .step-num {
    width: 26px;
    height: 26px;
    font-size: 12px;
  }
  .step-left {
    width: 30px;
    margin-right: 8px;
  }
  .step-desc .copyable-id-wrapper {
    padding: 2px 8px 2px 6px;
    gap: 3px;
  }
  .step-desc b.copyable-id {
    font-size: 13px;
  }
  .step-desc .copy-hint {
    font-size: 10px;
  }
}
</style>

<!-- 全局样式：覆盖挂载到 body 的 Element UI 组件（$confirm/$message/$notify），与页面粉紫色系统一 -->
<style>
/* MessageBox 确认框样式统一 */
.el-message-box {
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #f0d6e6;
  box-shadow: 0 12px 40px rgba(255, 96, 197, 0.18);
}
.el-message-box .el-message-box__header {
  padding: 18px 20px 10px;
}
.el-message-box .el-message-box__title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
}
.el-message-box .el-message-box__content {
  padding: 10px 20px 18px;
  font-size: 14px;
  color: #666;
}
.el-message-box .el-message-box__btns {
  padding: 0 20px 20px;
}
.el-message-box .el-button--primary {
  background: linear-gradient(135deg, #ff60c5 0%, #a855f7 100%);
  border: none;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(255, 96, 197, 0.3);
  font-weight: 600;
}
.el-message-box .el-button--primary:hover {
  opacity: 0.9;
}
.el-message-box .el-button--default {
  border-radius: 20px;
  border-color: #f0d6e6;
  color: #666;
}
.el-message-box .el-button--default:hover {
  color: #ff60c5;
  border-color: #ff60c5;
  background: #fff5fb;
}

/* Message 提示样式统一 */
.el-message {
  border-radius: 14px;
  border-color: #f0d6e6;
  box-shadow: 0 8px 24px rgba(255, 96, 197, 0.14);
  min-width: 260px;
}
.el-message--success .el-message__icon {
  color: #a855f7;
}
.el-message--warning .el-message__icon {
  color: #f59e0b;
}
.el-message--error .el-message__icon {
  color: #f43f5e;
}
.el-message .el-message__content {
  font-size: 14px;
  color: #333;
}

/* Notification 通知样式统一 */
.el-notification {
  border-radius: 18px;
  border: 1px solid #f0d6e6;
  box-shadow: 0 10px 32px rgba(255, 96, 197, 0.16);
  overflow: hidden;
}
.el-notification .el-notification__title {
  font-size: 15px;
  font-weight: 700;
  color: #333;
}
.el-notification .el-notification__content {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}
.el-notification--success {
  border-left: 4px solid #a855f7;
}
.el-notification--success .el-notification__title {
  color: #a855f7;
}
.el-notification--error {
  border-left: 4px solid #f43f5e;
}
.el-notification--error .el-notification__title {
  color: #f43f5e;
}
.el-notification .el-notification__closeBtn {
  color: #c0a0b8;
}
.el-notification .el-notification__closeBtn:hover {
  color: #ff60c5;
}
</style>
